import React from "react";
import { Modal } from "react-bootstrap";
import { Button, Col, FormGroup, Input, Label } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { AlertPopups } from "../../../components/AlertPopups";
import axios from "axios";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import { UserConsumer } from "../../../UserContext";

function TagAssetPopupModal(props) {
	const {
		showModal,
		isEditMode,
		onClose,
		itemRequisitionId,
		assetTobeEditedId,
		itemCategoryList,
		selectedTagAssetCategory,
		onTagAssetCategoryChange,
		assetCode,
		serialNo,
		onSerialNoChange,
		description,
		onDescriptionChange,
		clearFormValues,
	} = props;

	let token = null;
	const initialValues = {
		category: selectedTagAssetCategory?.label,
		assetCode: assetCode,
		serialNo: serialNo,
		description: description,
	};

	const validate = Yup.object().shape({
		category: Yup.string()
			.required("Select Category")
			.typeError("Invalid input")
			.nullable(),
		assetCode: Yup.string()
			.required("asset Code is required")
			.typeError("Invalid input"),
		description: Yup.string()
			.required("Description is required")
			.typeError("Invalid input")
			.max(600, "Max 600 characters allowed"),
	});

	const handleSubmit = () => {
		const formData = {
			categoryId: selectedTagAssetCategory?.value,
			assetTag: assetCode,
			serialNo: serialNo,
			description: description,
		};

		if (isEditMode) {
			// update Tag asset
			axios
				.put(
					`${ItemRequisitionAPI.PutTagAssets}/${itemRequisitionId}/TagAssets/${assetTobeEditedId}`,
					formData,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				)
				.then(({ status, message }) => {
					if (status === 200) {
						AlertPopups.successAlert.fire({
							text: "Tag Updated",
						});
					} else if (status === 400) {
						AlertPopups.ErrorAlert.fire({
							text: message,
						});
					}
					window.location.reload();
				})
				.catch((error) => {
					if (error.response)
						AlertPopups.ErrorAlert.fire({
							text: error.response.data.message,
						});
					else
						AlertPopups.ErrorAlert.fire({
							text: "Server Error",
						});
				});
		} // Create New Tag asset
		else {
			axios
				.post(
					`${ItemRequisitionAPI.PostTagAssets}/${itemRequisitionId}/TagAssets`,
					formData,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				)
				.then(({ status, message }) => {
					if (status === 200) {
						AlertPopups.successAlert.fire({
							text: "Tag Added",
						});
						window.location.reload();
					} else if (status === 400) {
						AlertPopups.ErrorAlert.fire({
							text: message,
						});
					}
					onClose();
				})
				.catch((error) => {
					if (error.response)
						AlertPopups.ErrorAlert.fire({
							text: error.response.data.message,
						});
					else
						AlertPopups.ErrorAlert.fire({
							text: "Server Error",
						});
				});
		}
		onClose();
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<Modal size="lg" show={showModal}>
						<Modal.Body className="p-0">
							<Formik
								enableReinitialize={true}
								initialValues={initialValues}
								validationSchema={validate}
								validateOnChange={true}
								onSubmit={() => {
									handleSubmit();
								}}
							>
								{({ errors, handleSubmit }) => (
									<form
										onSubmit={handleSubmit}
										className="itemReqPopupForm"
									>
										<FormGroup
											row
											id="row0"
											className="bottom-spacing topBorders  "
										>
											<Label sm={11}>
												Tag Assets Form
											</Label>
											<Col
												sm={1}
												className="d-flex"
												style={{
													justifyContent: "flex-end",
												}}
											>
												<button
													type="button"
													class="close"
													onClick={onClose}
													style={{ color: "white" }}
												>
													<span>×</span>
												</button>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label
												for="title"
												sm={3}
												md={3}
												lg={3}
											>
												Category{" "}
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={9} md={9} lg={9}>
												<CustomReactSelect
													options={itemCategoryList}
													value={
														selectedTagAssetCategory
													}
													onChange={(value) =>
														onTagAssetCategoryChange(
															value
														)
													}
													className={`formValueInput ${
														errors.category
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label
												for="title"
												sm={3}
												md={3}
												lg={3}
											>
												Asset Code{" "}
												<span className="required">
													*
												</span>
											</Label>
											<Col>
												<Input
													type="text"
													value={assetCode}
													disabled={true}
													className={`formValueInput ${
														errors.assetCode
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label
												for="selectPriority"
												sm={3}
												md={3}
												lg={3}
											>
												Serial No
											</Label>
											<Col>
												<Input
													type="text"
													value={serialNo}
													onChange={(event) => {
														onSerialNoChange(
															event.target.value
														);
													}}
													className={`formValueInput`}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label
												for="Description"
												sm={3}
												md={3}
												lg={3}
											>
												Description{" "}
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={9} md={9} lg={9}>
												<Input
													type="textarea"
													maxLength="400"
													value={description}
													onChange={(value) =>
														onDescriptionChange(
															value
														)
													}
													className={`formValueInput ${
														errors.description
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Col>
										</FormGroup>
										<div className="btns">
											{isEditMode ? (
												<>
													<Button
														className="submit-btn leftBtn"
														onClick={handleSubmit}
													>
														Update
													</Button>
													<Button
														className="reset-btn"
														onClick={
															clearFormValues
														}
													>
														Reset
													</Button>
												</>
											) : (
												<Button
													className="submit-btn leftBtn"
													onClick={handleSubmit}
												>
													Submit
												</Button>
											)}
										</div>
									</form>
								)}
							</Formik>
						</Modal.Body>
					</Modal>
				);
			}}
		</UserConsumer>
	);
}

export default TagAssetPopupModal;
